export default window.msi;
